// eslint-disable-next-line import/no-named-as-default
import styled from 'styled-components';

export const StyledTextInput = styled.input.attrs({ type: 'text' })`
  padding: 10px;
  font-size: 1rem;
  border: 2px solid #ccc;
  border-radius: 5px;
  outline: none;
  transition: border-color 0.2s ease;

  &:focus {
    border-color: #0077ff;
  }
`;
export const PinCardTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  margin-bottom: 32px;
`;
export const PinHeadWrapper = styled.span`
  align-self: stretch;
  font-family: 'Libre Baskerville', serif;
  color: #5f5f5f;
  font-size: 32px;
  font-style: normal;
  font-weight: 400;
  line-height: 42px;
`;
export const PinCardDescription = styled.span`
  align-self: stretch;
  color: #5f5f5f;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  font-family: 'Montserrat', sans-serif;
`;
export const PinSearchRowContainer = styled.div`
  display: flex;
  width: 100%;
  column-gap: 24px;

  @media screen and (max-width: 500px) {
    flex-direction: column;
    gap: 24px;
  }
`;

export const PinLblContainer = styled.div`
  color: #5f5f5f !important;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  text-transform: uppercase;
  font-family: 'Montserrat', sans-serif;
`;
export const PinLastnameInput = styled.input.attrs({ type: 'text' })`
  border: 1px solid #afafaf;
  display: flex;
  width: 100%;
  min-height: 44px;
  justify-content: center;
  align-items: center;
  gap: 12px;
  align-self: stretch;
  border-radius: 5px;
  padding-left: 12px;
  padding-right: 12px;
  font-family: 'Montserrat', sans-serif;
  color: #5f5f5f;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-overflow: ellipsis;
`;
export const PinRowContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  flex: 1 0 0;
  align-self: stretch;
`;
export const PinErrContainer = styled.div`
  margin-bottom: -28px;
`;
export const LnPErrContainer = styled.div`
  margin-bottom: -52px;
`;
export const PinInlineErr = styled.span`
  align-self: stretch;
  color: #eb0000;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  font-family: 'Montserrat', sans-serif;
`;
export const SearchInputGrpContainer = styled.div`
  margin-bottom: 32px;
  flex: 1 0 0;
`;
export const PinInputGrpContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  flex: 1 0 0;
  align-self: stretch;

  input {
    display: flex;
    width: 100%;
    min-height: 44px;
    justify-content: center;
    align-items: center;
    gap: 12px;
    align-self: stretch;
    border-radius: 8px;
    padding-left: 12px;
    padding-right: 12px;
  }
`;
export const PinSubmitBtnContainer = styled.div`
  display: flex;
  align-items: flex-start;
  align-content: flex-start;
  gap: 16px;
  align-self: stretch;
  flex-wrap: wrap;
  @media screen and (max-width: 500px) {
    justify-content: center;
    align-items: center;
    flex-direction: column-reverse;
    gap: 10px;
    flex: 1 0 0;
    width: 100%;
  }
  button {
    @media screen and (max-width: 500px) {
      width: 100%;
    }
  }
`;
export const SearchSUbmitButton = styled.button``;
